import { render } from "./RiProdoffering192.vue?vue&type=template&id=67b85c60"
import script from "./RiProdoffering192.vue?vue&type=script&lang=js"
export * from "./RiProdoffering192.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering192.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b85c60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b85c60', __exports__)) {
    api.reload('67b85c60', __exports__)
  }
  
  module.hot.accept("./RiProdoffering192.vue?vue&type=template&id=67b85c60", () => {
    api.rerender('67b85c60', render)
  })

}


export default __exports__